import { useDispatch } from "react-redux";
import { navigateTo } from "helpers/location-helpers";
import { MODAL_NAMES } from "constants/modal-names";
import { calculateEligiblityToShowUrgencySignalOnUniversalPdp } from "../urgency-signal/wrapper";
import HeapHelpers from "helpers/heap-helpers";
import Routes from "routes";
import { displayModal } from "actions/shared-actions";
import { isChurnedSubscriber } from "helpers/membership-helpers";
import RtrButton from "components/design-system/rtr-button";
import type { MembershipState } from "@rtr/godmother";
import { ctaText } from "rtr-constants";

type AvailabilityItem = {
  id: string;
  stock: number;
};

type SelectedSize = {
  sku: string;
  size: string;
};

export type ProspectAddToBagButtonProps = {
  availability: AvailabilityItem[];
  selectedSize: SelectedSize;
  membershipState: MembershipState; // Updated to use the imported MembershipState type
  userCanRejoin: boolean;
  rejoinUrl: string;
};

const ProspectAddToBagButton = ({
  availability,
  selectedSize,
  membershipState,
  userCanRejoin,
  rejoinUrl,
}: ProspectAddToBagButtonProps) => {
  const dispatch = useDispatch();

  const addToBag = () => {
    // I am duplicating the logic from `membership-item-dummy-atb-container` which Stephen built
    // So that once we get rid of the old PDP - we can delete the component directly
    const { isEligible, availabilityOfSelectedSku } = calculateEligiblityToShowUrgencySignalOnUniversalPdp(
      availability, // @TODO: Ensure this changes as intent/lens/mode changes
      selectedSize
    );

    HeapHelpers.fireHeapEvent("non-subscriber-membership-atb", {
      selectedSize,
      urgencySignalShown: isEligible,
      urgencySignalItemsLeft: availabilityOfSelectedSku,
      universalPdp: true,
    });

    if (userCanRejoin) {
      navigateTo(rejoinUrl);
    } else if (isChurnedSubscriber(membershipState)) {
      navigateTo(Routes.LP.plans);
    } else {
      dispatch(displayModal(MODAL_NAMES.PLANS_DRAWER));
    }
  };

  return (
    <RtrButton
      style="primary"
      className="my-4"
      dataTestId="updp-prospect-atb"
      dataHeapId="updp-prospect-atb"
      onClick={addToBag}
      fullWidth>
      {isChurnedSubscriber(membershipState) ? ctaText.REACTIVATE_SUBSCRIPTION : ctaText.ADD_TO_SHIPMENT}
    </RtrButton>
  );
};

export default ProspectAddToBagButton;
